import { render, staticRenderFns } from "./OverviewProfileHighlights.vue?vue&type=template&id=22cab65a"
import script from "./OverviewProfileHighlights.vue?vue&type=script&lang=js"
export * from "./OverviewProfileHighlights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports